import { UserPinnedQuoteDeleteRequestParams } from '@lio/api-types';
import { useQueryClient, useMutation } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

export const useDeletePinnedQuote = () => {
  const queryClient = useQueryClient();
  const client = useClient();
  const mutationFn = ({ userId, quoteId }: UserPinnedQuoteDeleteRequestParams) => {
    const url = `user/${userId}/pinned-quote/${quoteId}`;
    return client.delete(url);
  };
  const queryKey = ['quotes'];
  const result = useMutation({
    mutationFn,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey });
    },
    onError: () => {
      queryClient.invalidateQueries({ queryKey });
    },
  });
  return { ...result, deletePinnedQuote: result.mutate };
};
